
const typeUser = {
  ME: "me",
  COMPLAINANT: "complainant",
  INVOLVEDS: "involveds",
  INVOLVEDS_ACCOMPLICE: "involvedsAccomplice",
  INVOLVEDS_OFFENDER: "involvedsOffender",
  INVOLVEDS_VICTIM: "involvedsVictim",
  INVOLVEDS_WITNESS: "involvedsWitness",
  RESOURCES: "resources",
  EXTERNAL: "external",
  SYSTEM: "system",
};

const typeResource = {
  HUMAN: "human",
  ACCESS: "access",
  FINANCIAL: "financial",
  MATERIAL: "material",
};

const statusPlan = {
  PENDING: "pending",
  PROCESS: "process",
  COMPLETED: "completed",
};

export const enums = {
  typeUser,
  typeUserRoutes: {
    [typeUser.ME]: "currentReport.me",
    [typeUser.INVOLVEDS]: "currentReport.investigation.involvedsInfo",
    [typeUser.INVOLVEDS_ACCOMPLICE]: "currentReport.investigation.involvedsAccompliceInfo",
    [typeUser.INVOLVEDS_OFFENDER]: "currentReport.investigation.involvedsOffenderInfo",
    [typeUser.INVOLVEDS_VICTIM]: "currentReport.investigation.involvedsVictimInfo",
    [typeUser.INVOLVEDS_WITNESS]: "currentReport.investigation.involvedsWitnessInfo",
    [typeUser.RESOURCES]: "currentReport.investigation.humanResourcesInfo",
    [typeUser.EXTERNAL]: "currentReport.investigation.externalInfo",
    [typeUser.SYSTEM]: "currentReport.users",
  },
  typeResource,
  typeResourceRoutes: {
    [typeResource.HUMAN]: "currentReport.investigation.humanResourcesInfo",
    [typeResource.ACCESS]: "currentReport.investigation.accessResourcesInfo",
    [typeResource.FINANCIAL]: "currentReport.investigation.financialResourcesInfo",
    [typeResource.MATERIAL]: "currentReport.investigation.materialResourcesInfo",
  },
  statusPlan,
  sections: {
    researchFolder: "researchFolder",
    caseEvaluation: "caseEvaluation",
    scenarios: "scenarios",
    involveds: "involveds",
    activityPlan: "activityPlan",
    resources: "resources",
    interviews: "interviews",
    evidences: "evidences",
    financialImpact: "financialImpact",
    conclusion: "conclusion",
  }
};